import React from 'react'
import PropTypes from 'prop-types'
import ProjectWriteoffListItem from "./ProjectWriteoffListItem";

const ProjectWriteOffList = ({project_id, writeoffs, project, canEdit, canRemove}) => {

    return (
        <div className="d-flex flex-column">
            {writeoffs && writeoffs.map(wo => <ProjectWriteoffListItem canEdit={canEdit} canRemove={canRemove} key={wo.id} project_id={project_id} project={project} writeoff={wo}/>)}
        </div>
    )

}

ProjectWriteOffList.propTypes = {
    project_id: PropTypes.string.isRequired,
    writeoffs: PropTypes.array,
    project: PropTypes.object.isRequired,
    canEdit: PropTypes.bool,
    canRemove: PropTypes.bool
}

export default ProjectWriteOffList